import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";

import {
  airlinesProductivityFetchError,
  airlinesProductivityFetchRequest,
  airlinesProductivityFetchSuccess,
  dailyAirlinesProductivityFetchError,
  dailyAirlinesProductivityFetchRequest,
  dailyAirlinesProductivityFetchSuccess,
} from "./actions";
import { AirlinesProductivityActionTypes } from "./types";

export function* handleAirlinesProductivityFetch(
  action: ReturnType<typeof airlinesProductivityFetchRequest>
): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { search, status, page, pageSize, ordering, gateId } = action.payload;
    const res = yield call(
      callGet,
      "/airlines/productivity/",
      { search, status, page, pageSize, ordering, gateId },
      source.token
    );
    yield put(airlinesProductivityFetchSuccess(res.data));
  } catch (error) {
    yield put(airlinesProductivityFetchError(error.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleDailyAirlinesProductivityFetch(
  action: ReturnType<typeof dailyAirlinesProductivityFetchRequest>
): SagaIterator {
  try {
    const { airline, gateId } = action.payload;
    const res = yield call(callGet, `/airlines/productivity/${airline.toUpperCase()}/`, { gateId });
    yield put(dailyAirlinesProductivityFetchSuccess({ airline, items: res.data }));
  } catch (error) {
    yield put(dailyAirlinesProductivityFetchError(error.message));
  }
}

function* watchAirlinesProductivitySagas(): SagaIterator {
  yield takeLatest(AirlinesProductivityActionTypes.TABLE_FETCH_REQUEST, handleAirlinesProductivityFetch);
  yield takeLatest(AirlinesProductivityActionTypes.DAILY_FETCH_REQUEST, handleDailyAirlinesProductivityFetch);
}

export default watchAirlinesProductivitySagas;
